import { useAppStore } from '@/stores/app'
import { useCompanyStore } from '@/stores/company'
import { useFetchStore } from '@/stores/fetch'
import type { IConfig, IMe } from '@/types/User'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()
    return appStore.isLoggedIn()
}

let bootPromise: Promise<void> | null = null

/** Loads public config (also issues the CSRF cookie) and the current user, once. */
export const bootSession = (): Promise<void> => {
    if (bootPromise) return bootPromise
    bootPromise = (async () => {
        const appStore   = useAppStore()
        const fetchStore = useFetchStore()
        const cfg = await fetchStore.fetch('/config').get().json<IConfig>()
        if (cfg.statusCode.value === 200 && cfg.data.value) appStore.config = cfg.data.value
        await reloadMe()
    })()
    return bootPromise
}

export const reloadMe = async (): Promise<IMe | null> => {
    const appStore   = useAppStore()
    const fetchStore = useFetchStore()
    const { statusCode, data } = await fetchStore.fetch('/me').get().json<IMe>()
    if (statusCode.value === 200 && data.value) {
        appStore.setMe(data.value)
        return data.value
    }
    appStore.setMe(null)
    return null
}

/** Called after any successful sign-in: stores the user and loads their companies. */
export const signedIn = async (me: IMe, viaEmail: boolean) => {
    const appStore     = useAppStore()
    const companyStore = useCompanyStore()
    appStore.setMe(me)
    appStore.justSignedInWithEmail = viaEmail
    companyStore.reset()
    await companyStore.init()
}

export const signOut = async () => {
    const appStore     = useAppStore()
    const companyStore = useCompanyStore()
    const fetchStore   = useFetchStore()
    await fetchStore.fetch('/auth/logout').post().json()
    appStore.setLogout()
    companyStore.reset()
}
